module.exports = __webpack_public_path__ + "img/About1.4ddd5daa.png";